module.exports = {
  en: {
    'HRMS75EC1': {
      '10': 'For Year',
      '20': 'For Employee Code',
      '30': 'Or Department',
      '40': 'Record By',
      '50': 'Employee Code',
      '60': 'Name',
      '70': 'Position',
      '80': 'Job Description',
      '90': 'Level',
      '99': 'Request for Personal training',
      '100': 'Course Code',
      '110': 'Course Name',
      '120': 'Category',
      '130': 'Approve Status',
      '140': 'Remark Approve',
      '150': 'More Detail',
      '160': 'Course that should is in training',
      '170': 'Compentency gap analysis',
      '180': 'Basic Training Neet By Pos.',
      '190': 'Succession Plan',
      '200': 'History of Training'
    },
    'HRMS75EC2': {
      '10': 'Performance Evaluation',
      '20': 'For Employee',
      '30': 'Year',
      '40': 'Appr No.',
      '50': 'Seq.No',
      '60': 'Appraised by',
      '70': 'Date',
      '80': 'Section',
      '90': 'Description',
      '100': 'Full Score',
      '110': 'Score',
      '120': 'Average Score',
      '130': 'Total',
      '140': 'Appraisor s Comment',
      '150': 'Employee Comment',
      '160': 'List Of Tr.Course Req.',
      '170': 'Appraisal form'
    },
    'HRMS75EC3': {
      '10': 'Competency Gap Analysis',
      '20': 'For Employee Code',
      '30': 'Department',
      '40': 'Position',
      '50': 'Job Description',
      '60': 'List Of Competency',
      '70': 'Competency',
      '80': 'Description',
      '90': 'Score Required',
      '100': 'Score of Emp.',
      '110': 'Different',
      '120': 'Select All',
      '130': 'List Of Tr.Course Req.'
    },
    'HRMS75EC4': {
      '10': 'Basic Training need',
      '20': 'Department',
      '30': 'Position',
      '40': 'List of Training Req.',
      '50': 'Tr.Course',
      '60': 'Code',
      '70': 'Name',
      '80': 'Category',
      '90': 'Type Of Tr.',
      '100': 'Tr. Hrs.',
      '110': 'position must be trained',
      '120': 'From (Month)',
      '130': 'To (Month)'
    },
    'HRMS75EC5': {
      '10': 'Succession Plan',
      '20': 'For Employee Code',
      '30': 'Department',
      '40': 'Position',
      '50': 'List of position for succession',
      '60': 'Department',
      '70': 'Position',
      '80': 'Priority',
      '90': 'List Of Tr Course Required'
    },
    'HRMS75EC6': {
      '10': 'History of Training Report',
      '20': 'For Employee Code',
      '30': 'Department',
      '40': 'Position',
      '50': 'Course Code',
      '60': 'Course Name',
      '70': 'Year of Training',
      '80': 'Month',
      '90': 'Class',
      '100': 'Training Period',
      '110': 'Start Date',
      '120': 'End Date',
      '130': 'Expense',
      '140': 'Score',
      '150': 'Result',
      '160': 'แผนพื้นฐาน',
      '170': 'Other'
    },
    'HRMS75EC7': {
      '10': 'List of Training Course Required',
      '20': 'Course Code',
      '30': 'Course Name',
      '40': 'Category',
      '50': 'Type Of',
      '60': 'Training',
      '70': 'Training',
      '80': 'Hrs.',
      '90': 'Remarks For',
      '100': 'Development',
      '110': 'Select All'
    },
    'HRMS75EC8': {
      '10': 'Course Detail',
      '20': 'Course Code',
      '30': 'Category',
      '40': 'Type of Training',
      '50': 'Course Outline',
      '60': 'Cost Per Head',
      '70': 'Baht/Pers',
      '80': 'Trainee s Qualification'
    }
  },
  th: {
    'HRMS75EC1': {
      '10': 'สำหรับปี',
      '20': 'สำหรับพนักงาน',
      '30': 'หรือหน่วยงาน',
      '40': 'รหัสผู้บันทึก',
      '50': 'รหัสพนักงาน',
      '60': 'ชื่อ',
      '70': 'ตำแหน่ง',
      '80': 'ลักษณะงาน',
      '90': 'ระดับ',
      '99': 'ขออนุมัติแผนฝึกอบรมของพนักงาน',
      '100': 'รหัสหลักสูตร',
      '110': 'ชื่อหลักสูตร',
      '120': 'ประเภท',
      '130': 'สถานะการอนุมัติ',
      '140': 'หมายเหตุการอนุมัติ',
      '150': 'รายละเอียดเพิ่มเติม',
      '160': 'หลักสูตรที่ควรเข้าอบรม',
      '170': 'เปรียบเทียบความสามารถ',
      '180': 'แผนฝึกอบรมขั้นพื้นฐาน',
      '190': 'Succession Plan',
      '200': 'ประวัติการเข้าอบรมของพนักงาน'
    },
    'HRMS75EC2': {
      '10': 'ผลการประเมิน',
      '20': 'สำหรับพนักงาน',
      '30': 'ปี',
      '40': 'ครั้งที่',
      '50': 'ลำดับที่',
      '60': 'ประเมินผลโดย',
      '70': 'วันที่',
      '80': 'ส่วนที่',
      '90': 'รายละเอียด',
      '100': 'คะแนนเต็ม',
      '110': 'คะแนนที่ได้',
      '120': 'คะแนนเฉลี่ย',
      '130': 'รวม',
      '140': 'ความคิดเห็นของผู้ประเมิน',
      '150': 'ความคิดเห็นพนักงาน',
      '160': 'รายชื่อหลักสูตร',
      '170': 'แบบฟอร์มการประเมิน'
    },
    'HRMS75EC3': {
      '10': 'Competency Gap Analysis',
      '20': 'สำหรับพนักงาน',
      '30': 'หน่วยงาน',
      '40': 'ตำแหน่ง',
      '50': 'ลักษณะงาน',
      '60': 'List Of Competency',
      '70': 'รหัสความสามารถ',
      '80': 'รายละเอียด',
      '90': 'คะแนนที่ต้องการ',
      '100': 'คะแนนพนักงาน',
      '110': 'แตกต่าง',
      '120': 'เลือกทั้งหมด',
      '130': 'รายชื่อหลักสูตร'
    },
    'HRMS75EC4': {
      '10': 'แผนอบรมขั้นพื้นฐาน',
      '20': 'หน่วยงาน',
      '30': 'ตำแหน่ง',
      '40': 'รายชื่อหลักสูตรที่ต้องเข้าอบรม',
      '50': 'หลักสูตร',
      '60': 'รหัส',
      '70': 'ชื่อ',
      '80': 'หมวด',
      '90': 'ประเภท',
      '100': 'ชม.อบรม',
      '110': 'อายุตำแหน่งที่ต้องเข้าอบรม',
      '120': 'ตั้งแต่ (เดือน)',
      '130': 'ถึง (เดือน)'
    },
    'HRMS75EC5': {
      '10': 'Succession Plan',
      '20': 'สำหรับพนักงาน',
      '30': 'หน่วยงาน',
      '40': 'ตำแหน่ง',
      '50': 'รายชื่อตำแหน่งที่เป็น Candidate',
      '60': 'หน่วยงาน',
      '70': 'ตำแหน่ง',
      '80': 'ลำดับที่',
      '90': 'รายชื่อหลักสูตรที่ต้องอบรม'
    },
    'HRMS75EC6': {
      '10': 'ประวัติการเข้าอบรมของพนักงาน',
      '20': 'สำหรับพนักงาน',
      '30': 'หน่วยงาน',
      '40': 'ตำแหน่ง',
      '50': 'รหัสหลักสูตร',
      '60': 'ชื่อหลักสูตร',
      '70': 'ปีที่เข้าอบรม',
      '80': 'เดือน',
      '90': 'รุ่น',
      '100': 'วันที่เข้าอบรม',
      '110': 'วันที่เริ่มต้น',
      '120': 'วันสิ้นสุด',
      '130': 'ค่าใช้จ่าย',
      '140': 'คะแนนที่ได้',
      '150': 'ผลการประเมิน',
      '160': 'แผนพื้นฐาน',
      '170': 'อื่นๆ'
    },
    'HRMS75EC7': {
      '10': 'รายชื่อหลักสูตรที่ต้องอบรม',
      '20': 'รหัสหลักสูตร',
      '30': 'ชื่อหลักสูตร',
      '40': 'หมวด',
      '50': 'ประเภทการ',
      '60': 'อบรม',
      '70': 'จำนวน ช.ม.',
      '80': 'อบรม',
      '90': 'หมายเหตุ',
      '100': 'การพัฒนา',
      '110': 'เลือกทั้งหมด'
    },
    'HRMS75EC8': {
      '10': 'รายละเอียดหลักสูตร',
      '20': 'รหัสหลักสูตร',
      '30': 'หมวด',
      '40': 'ประเภทการอบรม',
      '50': 'Course Outline',
      '60': 'ค่าใช้จ่าย :',
      '70': 'บาท/คน',
      '80': 'คุณสมบัติผู้เข้าอบรม'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hrms75e.js